<template>
  <div
    class="disposalCard w-full h-full relative text-14px text-[#fff] p-5px
  "
  >
    <div class="warningInfo mt-10px text-[#FFFFFF]">
      <div class="mb-15px">
        <span class="text-[#FFFFFF99]">报警类型：</span>
        <span>智能识别报警-人员抽烟</span>
      </div>
      <div class="mb-15px">
        <span class="text-[#FFFFFF99]">报警地点：</span>
        <span>烟气净化间</span>
      </div>
      <div class="mb-15px">
        <span class="text-[#FFFFFF99]">报警时间：</span>
        <span>2023-09-20 12:20:30</span>
      </div>
      <div class="mb-15px">
        <span class="text-[#FFFFFF99]">处理状态：</span>
        <span class="text-[#11d45f]">已处理</span>
      </div>
      <div class="processing w-96px h-32px text-center">处理流程</div>
    </div>
    <CategoryTitle class="mb-10px mt-20px" title="报警视频联动"></CategoryTitle>
    <div class="vedioInfo mb-10px mt-10px">
      <div class="flex justify-between w-full">
        <div>
          <span class="text-[#FFFFFF99]">设备名称：</span>
          <span>楼层转角设备</span>
        </div>
        <div>
          <span class="text-[#FFFFFF99] ">所在区域：</span>
          <span>烟气净化间</span>
        </div>
      </div>
      <video class="w-full h-207px mt-10px bg-[#fff]"></video>
    </div>
    <div class="suggessBox relative p-10px mt-10px">
      <img
        class="absolute right-10px top-0"
        src="../../../../assets/images/smartSecurity/def.png"
        alt=""
      />
      <p class="sTitle mb-30px">已为您推荐最优风险事件处置方案</p>
      <p class="type text-[#FF9F2C] mb-5px">人员抽烟</p>
      <p>
        <span class="text-[rgba(255,255,255,1)]">可能导致的事故类型：</span>
        <span class="danger text-[#FF9F2C]">火灾、机械伤害</span>
      </p>
      <div class="measure mt-10px">
        <div class="flex justify-between items-center">
          <div>
            <span class="text-16px">安全管控措施：</span>
            <span class="text-[#41D8D8] cursor-pointer">查看所有></span>
          </div>
          <div>
            <span class="text-[#41D8D8] cursor-pointer">换一换</span>
            <!-- <img src="" alt="" /> -->
          </div>
        </div>
        <div class="text-[#ccc] mt-10px">
          <p>
            1、立即制止XXX行为；
          </p>
          <p>
            2、控制火灾发生的可燃物，尽量减少可燃物的存在；
          </p>
          <p>
            3、控制火灾发生的着火源，抓好电气设施防火；
          </p>
          <p>
            4、在建筑防火中，把一个大的空间划分成几个防火小空间，建筑之间保持适当距离；
          </p>
          <p>
            5、在建筑内部安装消防器材设施、保证人员能够疏散逃生的通道、标识和应急照明、广播等等；
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const CategoryTitle = () => {
  return import('@/components/cockpit/CategoryTitle')
}
export default {
  name: 'disposalCard',
  components: {
    CategoryTitle,
  },
  data() {
    return {
      total: 0,
      pageSize: 5,
      currentPage: 1,
      isShowDialog: false,
    }
  },
  methods: {
    reviewDetail(item) {
      this.isShowDialog = true
    },
    refresh() {
      this.isShowDialog = false
    },
  },
}
</script>
<style lang="scss" scoped>
.processing {
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05b0ff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  font-family: PingFang SC;
  font-weight: regular;
  font-size: 14px;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
}
.suggessBox {
  border-radius: 6px;
  // background: linear-gradient(0deg, #08142589 0%, #2f3d5216 100%);
  box-shadow: inset 0px 5px 20px 0.5px #2b2e348e;
  border: 2px solid #41d8d8;
  .sTitle {
    text-shadow: 0px 0px 11px 0px #00d1ff7f;
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 14px;
    line-height: normal;
    letter-spacing: 0px;
    text-align: left;
    color: linear-gradient(180deg, #ffffff 43%, #5cdbf7 78%) !important;
  }
}
</style>
